export default __webpack_public_path__ + "static/media/biz-icon.9a41142c.svg";